import React from "react";
import PropTypes from "prop-types";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";

import headerStyle from "assets/jss/material-dashboard-pro-react/components/headerStyle.jsx";
import config from "config/config.js";

function Header() {
  const image = `${config.imageRoot}logo/logo-quadrato-foodiestrip.png`;
  const imageLittle = `${
    config.imageRoot
  }logo/logo-quadrato-foodiestrip-mobile.png`;
  return (
    <div
      className="login-header"
      style={{
        backgroundImage: `url('${
          config.imageRoot
        }banner/banner-foodiestrip-header.png')`
      }}
    >
      <a title="foodiestrip.com" href={config.baseUrl}>
        <img
          className="logo_header_desktop"
          src={image}
          alt="foodiestrip-logos"
        />
        <img
          className="logo_header_mobile"
          src={imageLittle}
          alt="foodiestrip-logos"
        />
      </a>
    </div>
  );
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  t: PropTypes.func
};

export default withStyles(headerStyle)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.jsx